import { Card, CardContent, Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
const CardContentNoPadding = styled(CardContent)(`
  padding: 13px;
  &:last-child {
    padding-bottom: 10px;
  }
`);
const TripOperationsRiskRow = ({ dataItem, index }) => {
  return (
      <Card key={index} sx={{ mb: 1, fontSize: ".80em" }}>
        <CardContentNoPadding>
          <Typography variant="h6" gutterBottom>
            <Link to={`/trips/${dataItem.tripID}`}>{dataItem.tripID}</Link> — {dataItem.clientName} — {dataItem.tripDescription}
          </Typography>
          <Grid container spacing={1}>
             <Grid item xs={12} sm={12} md={3}>
              <Box>
                <strong>Risk Note:</strong> {dataItem.operationsRiskNote}
              </Box>
              <Box>
                <strong>Rec. Action:</strong> {dataItem.recommendedAction}
              </Box>
              <Box>
                <strong>Risk Level:</strong> {dataItem.operationsRiskLevel}
              </Box>
              <Box>
                <strong>Route OTP:</strong> {(dataItem.routeOTPPercent * 100).toFixed(0)}%
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box>
                <strong>Hub:</strong> {dataItem.hubName}
              </Box>
              <Box>
                <strong>Unit #:</strong> {dataItem.unitNumber}
              </Box>
              <Box>
                <strong>Driver:</strong> {dataItem.driverName}
              </Box>
              <Box>
                <strong>Driver OTP:</strong> {dataItem.driverOTPPercent ? `${(dataItem.driverOTPPercent * 100)?.toFixed(0)}%` : 'N/A'}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box>
                <strong>Pickup Time:</strong> {dataItem.pickupDateTime}
              </Box>

              <Box>
                <strong>Minutes to Pickup:</strong> {dataItem.minutesToPickup}
              </Box>
              <Box>
                <strong>Minutes to Leave:</strong> {dataItem.minutesToLeave}
              </Box>
              <Box>
                <strong>Time Zone:</strong> {dataItem.timeZone}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Box>
                <strong>Drive Time:</strong> {dataItem.driveTime}
              </Box>
              <Box>
                <strong>Last GPS (UTC):</strong> {dataItem.vehicleLastKnownGPSTimeUTC}
              </Box>
              <Box>
                <strong>GPS Delay (min):</strong> {dataItem.gpsUpdateDelayMinutes}
              </Box>
            </Grid>
           
          </Grid>
        </CardContentNoPadding>
      </Card>
  );
};
export default TripOperationsRiskRow;
